import React, { useEffect, useMemo } from 'react';
import { Trophy, Sparkles } from 'lucide-react';

const COLORS = ['#f59e0b', '#ef4444', '#10b981', '#3b82f6', '#a855f7', '#fbbf24', '#ffffff'];

export const DetailCelebration = ({ data, onClose }) => {
  const pieces = useMemo(
    () => Array.from({ length: 90 }, (_, i) => ({
      left: `${Math.random() * 100}%`,
      dx: `${(Math.random() - 0.5) * 240}px`,
      dur: `${2.4 + Math.random() * 2.2}s`,
      delay: `${Math.random() * 1.6}s`,
      color: COLORS[i % COLORS.length],
      w: 6 + Math.round(Math.random() * 7),
    })),
    [],
  );

  useEffect(() => {
    const t = setTimeout(onClose, 9000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-background/85 backdrop-blur-sm" data-testid="detail-celebration" onClick={onClose}>
      <div className="dt-confetti">
        {pieces.map((p, i) => (
          <i key={i} style={{ left: p.left, background: p.color, width: p.w, height: p.w * 1.8, animationDuration: p.dur, animationDelay: p.delay, '--dx': p.dx }} />
        ))}
      </div>
      <div className="dt-record-card relative w-[min(92vw,720px)] border border-primary/60 bg-card px-10 py-12 text-center" style={{ borderRadius: 3 }}>
        <div className="dt-record-ring mx-auto mb-6 flex h-20 w-20 items-center justify-center border border-primary/70 bg-primary/10" style={{ borderRadius: 3 }}>
          <Trophy className="h-10 w-10 text-primary" />
        </div>
        <p className="ent-label text-primary">Novo recorde pessoal</p>
        <h1 className="mt-2 font-display text-5xl font-black uppercase tracking-tight text-foreground sm:text-6xl">Você bateu seu recorde!</h1>
        <p className="mt-6 flex flex-col items-center gap-1 text-base text-muted-foreground">
          <span className="dt-timer text-6xl font-black leading-none text-foreground">{data?.today_count}</span>
          <span>carros finalizados hoje</span>
          {data?.previous_record ? <span className="text-sm">recorde anterior: <span className="font-bold text-foreground">{data.previous_record}</span></span> : <span className="text-sm">seu primeiro recorde</span>}
        </p>
        <div className="mt-8 flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-primary">
          <Sparkles className="h-4 w-4" /> Detail Department · Speed Motors
        </div>
        <button data-testid="celebration-close" onClick={onClose} className="ent-btn ent-btn-primary mt-8 h-9 px-6">Continuar</button>
      </div>
    </div>
  );
};
